import axios from 'axios';
import { settings } from '../../config';
import { getInitData } from '@/utils/getInitData';

export interface FreezedTasksResponse {
  tasks: Array<{
    id: number;
    status: string;
  }>;
}

export interface FreezedTasksRequest {
  tg_user_id: number;
  tg_user_locale: string;
  tg_user_first_name: string;
  tg_user_is_premium: boolean;
  tg_user_platform: string;
}

export function getFreezedTasks(
  callback: (data: FreezedTasksResponse) => void = () => {},
): Promise<FreezedTasksResponse> {
  const tg = window?.Telegram?.WebApp;

  if (!tg?.initDataUnsafe?.user?.id) {
    return Promise.reject(new Error('Telegram WebApp not initialized'));
  }

  // const userId = tg.initDataUnsafe.user.id;

  const requestData: FreezedTasksRequest = {
    tg_user_id: tg.initDataUnsafe.user.id,
    tg_user_locale: 'ru',
    tg_user_first_name: tg.initDataUnsafe.user.first_name,
    tg_user_is_premium: tg.initDataUnsafe.user.is_premium || false,
    tg_user_platform: tg.platform,
  };

  if (!tg?.initData) {
    throw new Error('initData отсутствует');
  }
  const encodedInitData = encodeURIComponent(getInitData());

  console.log(
    'Отправляем запрос на получение замороженных задач:',
    requestData,
  );

  return axios
    .post(
      `${settings.url}api/tasks/services/barzha/get?initData=${encodedInitData}`,
      requestData,
    )
    .then((response) => {
      console.log('====Ответ от сервера (BARZHA`):', response.data);
      callback(response.data);
      return response.data;
    })
    .catch((err) => {
      console.error('Ошибка при получении замороженных задач:', err);
      throw err;
    });
}

export function getAdWidget() {
  const tg = window.Telegram?.WebApp;

  // Если WebApp не инициализирован, возвращаем Promise.reject
  if (!tg?.initDataUnsafe?.user) {
    return Promise.reject(new Error('Telegram WebApp not initialized'));
  }

  const userId = tg.initDataUnsafe.user.id;
  const encodedInitData = encodeURIComponent(getInitData());
  const requestData = {
    tg_user_id: userId,
    tg_user_locale: 'ru',
    tg_user_first_name: tg.initDataUnsafe.user.first_name,
    tg_user_is_premium: tg.initDataUnsafe.user.is_premium || false,
    tg_user_platform: tg.platform,
  };

  return axios
    .post(
      `${settings.url}api/banners/barzha/widget?initData=${encodedInitData}`,
      requestData,
    )
    .then((response) => {
      console.log('Ответ от сервера (виджет рекламы):', response.data);
      return response.data;
    })
    .catch((err) => {
      console.error('Ошибка при получении виджета рекламы:', err);
      throw err;
    });
}

// Get Ad Widget Link
export const getAdLink = async (
  adCampaignId: number,
  title: string,
  description: string,
  image_href: string,
) => {
  const tg = window?.Telegram?.WebApp;
  const userId = tg?.initDataUnsafe?.user?.id;

  if (!tg?.initData) {
    throw new Error('initData отсутствует');
  }
  const encodedInitData = encodeURIComponent(getInitData());

  try {
    const requestData = {
      tg_user_id: tg.initDataUnsafe.user.id,
      tg_user_locale: 'ru',
      tg_user_first_name: tg?.initDataUnsafe?.user?.first_name,
      tg_user_is_premium: tg?.initDataUnsafe?.user?.is_premium || false,
      tg_user_platform: tg?.platform,
      ad_subscription_campaign_id: adCampaignId,
      title: title,
      description: description,
      image_href: image_href,
    };

    const response = await axios.post(
      `${settings.url}api/tasks/barzha/link/get?initData=${encodedInitData}`,
      requestData,
    );

    return response.data;
  } catch (error) {
    console.error('Ошибка при получении ссылки на рекламу:', error);
    throw error;
  }
};

// Get Ad Widget Link
export const getAdWidgetLink = async (adCampaignId?: number) => {
  const tg = window?.Telegram?.WebApp;
  const userId = tg?.initDataUnsafe?.user?.id;
  const encodedInitData = encodeURIComponent(getInitData());
  try {
    const requestData = {
      tg_user_id: userId,
      tg_user_locale: 'ru',
      tg_user_first_name: tg?.initDataUnsafe?.user?.first_name,
      tg_user_is_premium: tg?.initDataUnsafe?.user?.is_premium || false,
      tg_user_platform: tg?.platform,
    };

    const response = await axios.post(
      `${settings.url}api/banners/barzha/widget/${adCampaignId}/link?initData=${encodedInitData}`,
      requestData,
    );

    return response.data;
  } catch (error) {
    console.error('Ошибка при получении ссылки на рекламу:', error);
    throw error;
  }
};

// Claim Barzha Task
export const claimBarzhaTask = async (taskId: number): Promise<any> => {
  const tg = window?.Telegram?.WebApp;
  const userId = tg?.initDataUnsafe?.user?.id;

  if (!userId) {
    throw new Error('Telegram WebApp not initialized');
  }

  if (!tg?.initData) {
    throw new Error('initData отсутствует');
  }
  const encodedInitData = encodeURIComponent(getInitData());

  try {
    const response = await axios.post(
      `${settings.url}api/tasks/barzha/claim/${taskId}?initData=${encodedInitData}`,
    );

    return response.data;
  } catch (error) {
    console.error('Ошибка при получении награды за задание Barzha:', error);
    throw error;
  }
};

export const checkBarzhaTask = async (taskId: number): Promise<any> => {
  const tg = window?.Telegram?.WebApp;
  const userId = tg?.initDataUnsafe?.user?.id;

  if (!userId) {
    throw new Error('Telegram WebApp not initialized');
  }

  if (!tg?.initData) {
    throw new Error('initData отсутствует');
  }
  const encodedInitData = encodeURIComponent(getInitData());

  try {
    const response = await axios.post(
      `${settings.url}api/tasks/barzha/check/${taskId}?initData=${encodedInitData}`,
    );

    return response.data;
  } catch (error) {
    console.error('Ошибка при проверке статуса задания Barzha:', error);
    throw error;
  }
};

// AdMaster Widget API
export const getAdMasterWidget = async (): Promise<any> => {
  const tg = window?.Telegram?.WebApp;
  const user = tg?.initDataUnsafe?.user;

  if (!user) {
    throw new Error('Telegram WebApp not initialized');
  }

  const payload = {
    tg_user_id: user.id, // Используем реальный ID пользователя
    tg_user_locale: user.language_code,
    tg_user_first_name: user.first_name,
    keep_limit: 123,
    tg_user_is_premium: user.is_premium || false,
    tg_user_platform: tg.platform,
  };

  try {
    const response = await axios.post(
      `https://app.barzha.com/api/widget/67`,
      payload,
      {
        headers: { 'Content-Type': 'application/json' },
      },
    );

    return response.data;
  } catch (error) {
    console.error('Ошибка при получении AdMaster виджета:', error);
    throw error;
  }
};

// AdMaster Widget Click API
export const clickAdMasterWidget = async (campaignId: string): Promise<any> => {
  const tg = window?.Telegram?.WebApp;
  const user = tg?.initDataUnsafe?.user;

  if (!user || !campaignId) {
    throw new Error('Telegram WebApp not initialized or missing campaign ID');
  }

  const payload = {
    tg_user_id: user.id, // Используем реальный ID пользователя
    tg_user_locale: user.language_code,
    tg_user_first_name: user.first_name,
    keep_limit: 123,
    tg_user_is_premium: user.is_premium || false,
    tg_user_platform: tg.platform,
  };

  try {
    const response = await axios.post(
      `https://app.barzha.com/api/widget/click/67/${campaignId}`,
      payload,
      {
        headers: { 'Content-Type': 'application/json' },
      },
    );

    return response.data;
  } catch (error) {
    console.error('Ошибка при клике по AdMaster виджету:', error);
    throw error;
  }
};

export const sendBarzhaClick = async () => {
  if (!getInitData()) {
    throw new Error('initData отсутствует');
  }
  const initData = encodeURIComponent(getInitData());
  const url = `${settings.url}api/banners/barzha/click?initData=${initData}`;

  console.log('[FLYER_CPC] POST:', url);

  try {
    const response = await axios.post(url);
    // await handleFlyerCpcCheckOnBack(campaignId);
    console.log('[FLYER_CPC] POST response:', response);
    return response.data;
  } catch (error) {
    console.error('[FLYER_CPC] Claim error:', error);
    throw error;
  }
};

export const tadsClickSend = async () => {
  if (!getInitData()) {
    throw new Error('initData отсутствует');
  }
  const initData = encodeURIComponent(getInitData());
  const url = `${settings.url}api/banners/tads/click?initData=${initData}`;

  console.log('[FLYER_CPC] POST:', url);

  try {
    const response = await axios.post(url);
    // await handleFlyerCpcCheckOnBack(campaignId);
    console.log('[FLYER_CPC] POST response:', response);
    return response.data;
  } catch (error) {
    console.error('[FLYER_CPC] Claim error:', error);
    throw error;
  }
};
